import * as Icon from 'react-bootstrap-icons';

const game = {
    "Immigration": {
        "version": 6,
        "icon": <img src="/icons/immigration2.svg" />,
        "questions": [
            {
                "statement": "The US should create a new type of visa for certain undocumented immigrants which gives them a path to citizenship.",
                "americansAgree": 58,
                "republicansAgree": 45,
                "democratsAgree": 75,
                "contextFor": <>
                    <p>The fact is that there are many industries in the United States that need immigrant workers, because Americans won’t take those jobs. That is why they currently hire millions of them. It would be much better if this process was done in a legal way, and to ensure American workers get the first crack at those jobs. It is also important that immigrant workers are paid the kinds of wages that go to Americans, so they do not undercut American workers, and pay taxes on their wages. All this can only be done if we have a legal system of guest workers that provides enough work visas.</p>
                    <p>As we know it is very hard to stop people from coming here if they need work and there are employers who want to hire them. So, the real choice is between continuing to have illegal workers come to the US, being paid very low wages under the table and driving down wages, or having workers come here legally that have to be paid fair wages, and pay taxes on those wages. This proposal is trying to deal with the reality of the situation that there will always be immigrant workers coming to the US, and improve the situation for everyone.</p>
                </>,
                "contextAgainst": <>
                    <p>This whole idea of trying to solve the problem of illegal workers by replacing them with legal workers fails to address the underlying problem. Most illegal workers have only a high school education or less, and so they compete directly with Americans for low-wage jobs, where wages have been stagnant for decades. It is Economics 101 that when wages are low it is because there is too big of a supply of workers. Having more legal immigrant workers does not change the supply of workers, and thus does not help raise wages for Americans.</p>
                    <p>While advocates of this proposal for guest workers may claim that it will think of American workers first, the chances are that the government will think of corporations first, and the corporations want an oversupply of labor so that they can keep wages low. That means they will pressure the government to look the other way and let the corporations hire guest workers who will undercut American workers, even when there are American workers still in need of a good-paying job.</p>
                </>
            },
            // {
            //     "statement": "The US should undertake a program of mass deportation with the goal of finding, detaining, and deporting most or all of the 11 million people living in the US without legal status.",
            //     "americansAgree": 26,
            //     "republicansAgree": 40,
            //     "democratsAgree": 14,
            //     "contextFor": <><p>Placeholder.</p></>,
            //     "contextAgainst": <><p>Placeholder.</p></>,
            // },
            {
                "statement": "The US should increase the number of Border Patrol agents from about 20,000 to 22,000 and provide more funding for surveillance. ",
                "americansAgree": 70,
                "republicansAgree": 74,
                "democratsAgree": 71,
                "contextFor": <><p>Placeholder.</p></>,
                "contextAgainst": <><p>Placeholder.</p></>,
            },
            {
                "statement": "The US should build more walls along the southern border by replacing existing fencing with walls and build walls where no barriers currently exist.",
                "americansAgree": 55,
                "republicansAgree": 72,
                "democratsAgree": 43,
                "contextFor": <><p>Placeholder.</p></>,
                "contextAgainst": <><p>Placeholder.</p></>,
            },
            // {
            //     "statement": "The US should require employers to verify that all new hires are legally allowed to work in the US by using the E-Verify system.",
            //     "americansAgree": 68,
            //     "republicansAgree": 64,
            //     "democratsAgree": 74,
            //     "contextFor": <><p>Placeholder.</p></>,
            //     "contextAgainst": <><p>Placeholder.</p></>,
            // },
            // {
            //     "statement": "The US should increase the number of migrant workers who enter the US legally by increasing the number of work visas available, provided there is a demand for such workers.",
            //     "americansAgree": 67,
            //     "republicansAgree": 53,
            //     "democratsAgree": 84,
            //     "contextFor": <><p>Placeholder.</p></>,
            //     "contextAgainst": <><p>Placeholder.</p></>,
            // },
            // {
            //     "statement": "The US should require employers to use E-Verify AND increase the number of work visas when needed.",
            //     "americansAgree": 74,
            //     "republicansAgree": 67,
            //     "democratsAgree": 85,
            //     "contextFor": <><p>Placeholder.</p></>,
            //     "contextAgainst": <><p>Placeholder.</p></>,
            // },
            // {
            //     "statement": "The US should hire several hundred more immigration judges in order to speed up the processing of asylum cases.",
            //     "americansAgree": 58,
            //     "republicansAgree": 46,
            //     "democratsAgree": 74,
            //     "contextFor": <><p>Placeholder.</p></>,
            //     "contextAgainst": <><p>Placeholder.</p></>,
            // },
        ],
    },
    "Stock Trading": {
        "version": 1,
        "icon": <img src="/icons/ICON.svg" />,
        "questions": [
            {
                "statement": "The US should ban stock trading for Members of Congress",
                "americansAgree": 86,
                "republicansAgree": 87,
                "democratsAgree": 88,
                "contextFor": <><p>Placeholder.</p></>,
                "contextAgainst": <><p>Placeholder.</p></>,
            },
            {
                "statement": "The US should ban stock trading for the President, Vice President and members of the Supreme Court",
                "americansAgree": 86,
                "republicansAgree": 87,
                "democratsAgree": 90,
                "contextFor": <><p>Placeholder.</p></>,
                "contextAgainst": <><p>Placeholder.</p></>,
            },
            {
                "statement": "The US should NOT ban stock trading for all federal employees",
                "americansAgree": 59,
                "republicansAgree": 57,
                "democratsAgree": 62,
                "contextFor": <><p>Placeholder.</p></>,
                "contextAgainst": <><p>Placeholder.</p></>,
            },
        ],
    },
    "Social Security": {
        "version": 1,
        "icon": <img src="/icons/ICON.svg" />,
        "questions": [],
    },
    "Affordable Housing ": {
        "version": 1,
        "icon": <img src="/icons/ICON.svg" />,
        "questions": [],
    },
    "Health Care Costs": {
        "version": 1,
        "icon": <img src="/icons/ICON.svg" />,
        "questions": [],
    },
    "Families & Children": {
        "version": 1,
        "icon": <img src="/icons/ICON.svg" />,
        "questions": [],
    },
    "Energy & Environment": {
        "version": 1,
        "icon": <img src="/icons/ICON.svg" />,
        "questions": [],
    },
    "International Trade": {
        "version": 1,
        "icon": <img src="/icons/ICON.svg" />,
        "questions": [],
    },
    "NATO": {
        "version": 1,
        "icon": <img src="/icons/ICON.svg" />,
        "questions": [],
    },
    "Abortion": {
        "version": 1,
        "icon": <img src="/icons/abortion.svg" />,
        "questions": [],
    },
}

export function getSave() {
    const answer = {
        youAgree: null,
        americansAgree: null,
        democratsAgree: null,
        republicansAgree: null,
    }

    let save = JSON.parse(JSON.stringify(game));
    for (const key in save) {
        save[key].answers = [];
        for (let i = 0; i < save[key].questions.length; i++) save[key].answers.push({ ...answer });
        delete save[key].questions;
        delete save[key].icon;
        save[key].onQuestion = 0;
        save[key].onPart = 0;
        save[key].onResults = false;
    }

    let localSave = {};
    try {
        localSave = JSON.parse(localStorage.getItem('save'));

        for (const key in localSave) {
            if (save[key]) {
                if (localSave[key].version < save[key].version) delete localSave[key];
            }
        }
    } catch (err) { }

    const newSave = { ...save, ...localSave };
    saveGame(newSave);

    return newSave;
}

export function saveGame(save) {
    localStorage.setItem('save', JSON.stringify(save));
}

export default game;
